import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { RestaurantRole } from "@/store/AuthStore";
import { rootStore } from "@/store/RootStore";

import { PATHS } from "../path";

export const RestaurantRedirect = () => {
  const navigate = useNavigate();
  const { restaurantAccess } = rootStore.authStore;

  useEffect(() => {
    switch (restaurantAccess) {
      case RestaurantRole.GROUP:
        navigate(PATHS.RESTAURANT.GROUP.ROOT, { replace: true });
        break;
      case RestaurantRole.BRAND:
        navigate(PATHS.RESTAURANT.BRAND.ROOT, { replace: true });
        break;
      case RestaurantRole.BRANCH:
        navigate(PATHS.RESTAURANT.BRANCH.ROOT, { replace: true });
        break;
      default:
        navigate(PATHS.RESTAURANT.ROOT, { replace: true });
    }
  }, [restaurantAccess, navigate]);

  return null;
};
